import React from "react";
import { SvgIcon } from "@mui/material";

export function MisProductosIcon() {
    return (
        <SvgIcon
            component={() => (
                <img
                    src="https://s3-sa-east-1.amazonaws.com/pricingcompass-imagenes/mis_productos.svg"
                    alt="misproductos-icon"
                />
            )}
        />
    );
}
